var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vSelect',{class:( _obj = {
    'mol-autocomplete-dropdown': true
  }, _obj['mol-autocomplete-dropdown--error'] = _vm.error, _obj ),attrs:{"options":_vm.options,"placeholder":_vm.placeholder,"value":_vm.value,"loading":_vm.loading,"clearable":_vm.clearable,"disabled":_vm.disabled,"multiple":_vm.multiple,"searchable":_vm.searchable,"map-keydown":_vm.onKeyDown},on:{"input":_vm.onChange},scopedSlots:_vm._u([{key:"open-indicator",fn:function(ref){
  var attributes = ref.attributes;
return [_c('span',_vm._b({},'span',attributes,false),[_vm._v("▼")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }